import PostSliderItem from './post-slider-item';

const PostSliderBlogItem = ({ post, ...props }) => {
	const dateFormatter = new Intl.DateTimeFormat('en-US', {
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	});
	return (
		<PostSliderItem post={post} {...props}>
			<div className="post-slider__title">
				{/* eslint-disable */}
				<span
					dangerouslySetInnerHTML={{
						__html: post.title.rendered,
					}}
				/>
				{/* eslint-enable */}
			</div>
			<span className="post-slider__date">
				{dateFormatter.format(new Date(post.date))}
			</span>
		</PostSliderItem>
	);
};

export default PostSliderBlogItem;
